import { createElementBlock as o, openBlock as r, createElementVNode as l } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(d, e) {
  return r(), o("svg", n, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4 5.413A4.413 4.413 0 0 1 8.413 1h4.822c.42 0 .825.157 1.135.44l5.007 4.577c1.133 1.036.4 2.925-1.135 2.925h-4.06c-.929 0-1.682-.754-1.682-1.683V3H8.413A2.413 2.413 0 0 0 6 5.413v4.694a1 1 0 1 1-2 0zm10.5-1.144 2.924 2.673H14.5zM19 11a1 1 0 0 1 1 1v5.587A4.413 4.413 0 0 1 15.587 22H8.413A4.413 4.413 0 0 1 4 17.587V14a1 1 0 1 1 2 0v3.587A2.413 2.413 0 0 0 8.413 20h7.174A2.413 2.413 0 0 0 18 17.587V12a1 1 0 0 1 1-1",
      "clip-rule": "evenodd"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.032 12a1 1 0 0 1 1-1H15a1 1 0 1 1 0 2H9.032a1 1 0 0 1-1-1M8 15.998a1 1 0 0 1 1-1h5.968a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const c = { render: t };
export {
  c as default,
  t as render
};
//# sourceMappingURL=ic_document_wrote-DgzZ12wp.js.map
